import React from 'react';

import { useSelector } from 'react-redux';
import { BuilderItem } from '../../components/BuilderItem';
import { getBuilders } from '../../selectors/newbuilding';

export const BuilderContainer = () => {
  const builders = useSelector(getBuilders);

  return <BuilderItem builders={builders} />;
};
